export const environment = {
  production: false,
  entityType: 'EKAMPUS',
  urlDEV: 'https://nstaging-api.certikap.com/api/v1',
  urlDEV_images: 'https://nstaging-api.certikap.com/uploads/users/',
  urlDownload: 'https://nstaging-api.certikap.com/uploads/generated-csv/cron/exports/',
  urlDownloadCertification: 'https://nstaging-api.certikap.com/uploads/generated-csv/certifications/',
  formURL: 'https://staging.certikap.com/v1/form/auto-inscription/',
  ELMS_url: 'https://kaptitude.elmg.net/',
};


